<div
  class="h-[{{ height() }}px] w-[{{
    width()
  }}px] rounded-5 animate-pulse bg-[#DDDEE0]"
></div>
